import { type FC, useMemo } from 'react'
import { useRange, type UseRefinementListProps } from 'react-instantsearch'
import { useIntl } from 'react-intl'

import { productSearchGetRefinementLabel } from '../productSearchGetRefinementLabel'
import {
  ProductSearchRefinement,
  ProductSearchRefinementContext,
} from '../ProductSearchRefinement'
import { productSearchRefinementRangeRenderValue } from '../ProductSearchRefinementRange'

import { ProductSearchRefinementDiscountListbox } from './ProductSearchRefinementDiscountListbox'

type ProductSearchRefinementDiscountRangeProps = Pick<
  UseRefinementListProps,
  'attribute'
> & {
  hidden: boolean
}

export const ProductSearchRefinementDiscountRange: FC<
  ProductSearchRefinementDiscountRangeProps
> = ({ attribute, hidden }) => {
  const intl = useIntl()

  const refinementRange = useRange({ attribute })

  const { canRefine, start } = refinementRange

  const contextValue = useMemo(
    () => ({
      refinementRange,
      refinementRangeOptions: {
        attribute,
      },
    }),
    [attribute, refinementRange],
  )

  if (hidden || !canRefine) {
    return null
  }

  const formLabel = productSearchGetRefinementLabel(attribute, intl)

  return (
    <div>
      <ProductSearchRefinementContext value={contextValue}>
        <ProductSearchRefinement
          attribute={attribute}
          data-qa-id={`form-${formLabel}`}
          renderValue={() =>
            productSearchRefinementRangeRenderValue(formLabel, start)
          }
          slotProps={{
            listbox: {
              title: formLabel,
            },
          }}
          slots={{
            listbox: ProductSearchRefinementDiscountListbox,
          }}
        />
      </ProductSearchRefinementContext>
    </div>
  )
}
